import React from 'react'
import './SomeQuotes.css'

const SomeQuotes = () => {
    return (
        <div className="some-quotes">
            <q className="some-quotes-q">
                Success breeds Success.
            </q>
        </div>
    )
}

export default SomeQuotes
